import { Stack } from "components/atoms/Stack";

export const NavigationLinks = ({ children }) => {
  return <Stack direction="horizontal" spacing={1}>{children}</Stack>;
};
